export default __webpack_public_path__ + "static/carbon-4ca56ae0741a73dea11ad3ce5d673511.jpg";